import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SearchMadesWrapper from '../SearchMades/SearchMadesWrapper'
import animations from '../../../../utils/animations'
import * as searchHistoryDuck from '../searchHistoryDuck'

class SearchHistoryPanel extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    mySearchMades: PropTypes.array,
    performRetrieveMySearchHistory: PropTypes.func.isRequired,
    searchFilter: PropTypes.string.isRequired,
  }

  componentWillMount() {
    this.props.performRetrieveMySearchHistory()
  }

  componentDidMount() {
    window.searchHistoryPanelAnimation = animations.searchHistoryPanelAnimation(
      '#searchHistoryPanel',
    )
  }

  render() {
    const { children, mySearchMades, searchFilter } = this.props
    const historySearches = mySearchMades.filter(searchMade => searchMade.searchType === searchFilter.toLowerCase())

    return (
      <div
        id="searchHistoryPanel"
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          right: -300,
          height: '100vh',
          width: 300,
          backgroundColor: 'white',
          borderLeft: '1px solid #ccc',
          padding: 5,
          zIndex: 1,
          overflowY: 'auto',
        }}
      >
        <div style={{padding: 5}}>
          <a href=""
             onClick={e => {
               e.preventDefault()
               if(window.searchHistoryPanelAnimation) window.searchHistoryPanelAnimation.reverse()
             }}
             style={{color: 'black'}}
          >
            <i className="fal fa-times"/>
          </a>
        </div>
        <h5 className="text-info">Saved {searchFilter} Searches:</h5>
        {children}
        <br/><br/>
        <h5 className="text-info">Recent {searchFilter} Searches:</h5>
        <SearchMadesWrapper
          showUser={false}
          searchMades={historySearches}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  mySearchMades: searchHistoryDuck.getSearchMades(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({
  performRetrieveMySearchHistory: searchHistoryDuck.performRetrieveMySearchHistory,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SearchHistoryPanel)



// WEBPACK FOOTER //
// ./src/components/ui/SearchHistory/SearchHistoryPanel/SearchHistoryPanel.js